import React, { Component } from 'react';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as Down } from '../../../assets/svg/down-arrow-search.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/chevron-down.svg';
import { ReactComponent as Minus } from '../../../assets/svg/minus-circle.svg';
import { withRouter } from '../../../services/withRoute';
import LoadingBar from '../../components/global/loadingBar';
import { getApolloContext, gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import DataTableCompact from '../../components/DataTableCompact';
import Tree from '../../components/tree';
import { ReactComponent as Search } from '../../../assets/svg/search-img.svg';
import _ from 'lodash';
import Select, { components } from 'react-select';
//import { ReactComponent as Minus } from '../../../assets/svg/minus-circle.svg';
const getHddInfo = gql`
	query HddInfo($hddIdentifier: String!) {
		hddInfo(hddIdentifier: $hddIdentifier) {
			category
			isDeleted
			qrCode
			size
			branch {
				_id
				branchId
			}
			projectSlNo
			projectTitle
			responsibleUser
			transactionLogs {
				backupSize
				createdAt
			}
			updatedAt
			updatedBy
			comments {
				_id
				comment
				createdAt
				createdBy
				userId
			}
			contents {
				files {
					fileType
				}
			}
			createdAt
			createdBy
			tenantId
			projectId
			model
			id
			backupLogs {
				createdBy {
					name
				}
			}
			deletedAt
			deletedBy
			isHddActive
			isPurchasedByClient
			location
			manufacturer
			manufacturerId
		}
	}
`;
const getVendorInfo = gql`
	query VendorInfo($vendorId: String!) {
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			vendorId
			isSuperHuemn
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
		}
	}
`;
const getTenantUserList = gql`
	query VendorUsers {
		vendorUsers {
			accessibleTenants {
				tenant_id
			}
			id
			firstName
			lastName
			displayName
		}
	}
`;
const getBranchList = gql`
	query BranchesList {
		branchesList {
			id
			code
			branchId
			description
			address
			city
			state
		}
	}
`;
const receiveHardDrive = gql`
	mutation ReceiveHardDrive(
		$qrCodes: [String!]!
		$branchId: String
		$receivedFrom: LogUserInput
		$notes: String
	) {
		receiveHardDrive(
			qrCodes: $qrCodes
			branchId: $branchId
			receivedFrom: $receivedFrom
			notes: $notes
		) {
			message
		}
	}
`;
class ReceiveHardDrives extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			hardDriveInfoList: [],
			searchValue: '',
			workspacesFilters: [],
			calledqrcodes: [],
			tenantUserList: [],
			namesList: [],
			namesList2: [],
			showError: false,
			calledworkspaceIds: [],
			branchesListOption: [],
			selectedValue: {},
			selectedValue2: {},
			message: '',
			name: '',
			note: '',
			id: '',
			isAPISubmitting: false,
		};
	}
	componentDidMount = () => {
		this.getTenantUsers(getTenantUserList);
		this.getVendorsWorkspaces(
			getVendorInfo,
			{
				vendorId: this.props.params.vendorID,
			},
			'modify-object',
		);

		this.getBranchList(getBranchList);
	};
	getWorkspacekey = (name) => {
		if (this.state.workspacesFilters.length !== 0) {
			for (let i = 0; i < this.state.workspacesFilters.length; i++) {
				if (this.state.workspacesFilters[i].workspaceid === name) {
					return this.state.workspacesFilters[i].workspaceKey;
				}
			}
		}
		return '';
	};
	goBack = (e) => {
		// this.props.navigate(`/${this.props.params.vendorID}/harddrives`)
		this.props.navigate(-1);
	};
	fetchHDWithSearching = async () => {
		if (
			this.state.searchValue.length >= 8 &&
			!this.state.calledqrcodes.includes(this.state.searchValue)
		) {
			let filters = {
				hddIdentifier: this.state.searchValue,
			};

			await this.getHddInfo(getHddInfo, filters);
			this.setState(
				{
					calledqrcodes: [...this.state.calledqrcodes, this.state.searchValue],
				},
				() => this.setAssignedToUser(),
			);
			// this.setState({
			// 	searchValue: '',
			// });
		}
	};
	setAssignedToUser = async () => {
		//let tempArray = [];

		/* for (let i = 0; i < this.state.tenantUserList.length; i++) {
			if (this.allWorkspacesfound(this.state.tenantUserList[i].accessibleTenants)) {
				// let newArray = tempArray.filter((el) => {
				// 	return el.id !== this.state.tenantUserList[i].id;
				// });
				// tempArray = newArray;
				tempArray.push(this.state.tenantUserList[i]);
			}
		} */
		// await this.setState(
		// 	{
		// 		tenantUserList: tempArray,
		// 	},
		// 	() => {
		// 		this.namesList2Update();
		// 	},
		// );
		await this.namesList2Update(this.state.tenantUserList);
	};

	namesList2Update = async (myarray) => {
		let temparray = [];
		for (let i = 0; i < myarray.length; i++) {
			temparray.push({
				value: myarray[i].id,
				label: myarray[i].displayName
					? myarray[i].displayName
					: myarray[i].firstName + ' ' + myarray[i].lastName,
			});
		}
		// await this.setState({
		// 	prevNamesList: this.state.namesList2,
		// });
		await this.setState({
			namesList2: temparray,
		});
	};
	allWorkspacesfound(userlist) {
		let tenantIDList = _.map(userlist, (tenant) => tenant.tenant_id);
		// for (let i = 0; i < userlist.length; i++) {
		// 	tenantIDList.push(userlist[i].tenant_id);
		// }

		let flag = true;
		_.map(this.state.calledworkspaceIds, (tenantId) => {
			if (!tenantIDList.includes(tenantId)) {
				// return false;
				flag = false;
			}
		});

		return flag;
	}
	handleSearch = (e) => {
		this.setState(
			{
				searchValue: e.target.value.toUpperCase(),
			},
			() => {
				this.fetchHDWithSearching();
			},
		);
	};
	minusClickHandler = (id, qrcode) => {
		let newArr = this.state.hardDriveInfoList.filter((el, idx) => {
			return el.id !== id;
		});
		this.setState(
			{
				hardDriveInfoList: newArr,
			},
			() => {
				this.updateWorkspaces();
			},
		);
		let newArr2 = this.state.calledqrcodes.filter((el, index) => {
			return el !== qrcode;
		});
		this.setState({
			calledqrcodes: newArr2,
		});
	};
	updateWorkspaces = async () => {
		if (this.state.hardDriveInfoList.length === 0) {
			this.setState({
				calledworkspaceIds: [],
				namesList2: [],
			});
		} else {
			let temparray = this.state.calledworkspaceIds;
			for (let i = 0; i < this.state.calledworkspaceIds.length; i++) {
				if (this.tenantIdFound(this.state.calledworkspaceIds[i]) === false) {
					let newArray = temparray.filter((el) => {
						return el == this.state.calledworkspaceIds[i];
					});
					temparray = newArray;
				}
			}

			await this.setState(
				{
					calledworkspaceIds: temparray,
				},
				//async () => this.setAssignedToUser(),
			);

			// this.setAssignedToUser();
		}
	};
	tenantIdFound(id) {
		if (this.state.hardDriveInfoList.length > 0) {
			for (let i = 0; i < this.state.hardDriveInfoList.length; i++) {
				if (this.state.hardDriveInfoList[i].tenantId === id) {
					return true;
				}
			}
			return false;
		}
		return false;
	}
	receiveHardDriveAPICall = () => {
		if (this.state.isAPISubmitting === false) {
			this.setState(
				{
					isAPISubmitting: true,
				},
				() => {
					let json = {
						qrCodes: this.state.calledqrcodes,
					};
					if (this.state.note) {
						json.notes = this.state.note;
					}
					if (_.size(this.state.selectedValue) > 0 && this.state.selectedValue.value) {
						json.branchId = this.state.selectedValue.value;
					}
					if (_.size(this.state.name) > 0 && _.size(this.state.id) > 0) {
						json = {
							...json,
							receivedFrom: {
								id: this.state.id,
								name: this.state.name,
							},
						};
					}
					this.receiveHardDrive(receiveHardDrive, json);
				},
			);
		}
	};
	render() {
		return (
			<>
				{this.state.tenantUserList.length > 0 ? (
					<div className="assign-receive-container">
						<div className="arc-header">
							<div className="back-btn" onClick={(e) => this.goBack(e)}>
								<Back style={{ width: '20px', height: '20px' }} />
							</div>
							<div className="arch-item">
								<span>
									<b
										style={{
											fontSize: '18px',
										}}
									>
										Hard Drives
									</b>
								</span>
							</div>
							<div className="next-btn">
								{' '}
								<Back style={{ width: '20px', height: '20px' }} />
							</div>
							<div className="arch-item">
								<span
									style={{
										fontSize: '18px',
									}}
								>
									Receive
								</span>
							</div>

							<div className="actn-btn">
								<a onClick={(e) => this.receiveHardDriveAPICall()}>
									Receive Hard Drive
								</a>
							</div>
						</div>
						<div
							style={{
								display: 'flex',
							}}
						>
							<div
								style={{
									width: '70%',
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									padding: '0px 64px',
								}}
								className="qrcode-search-section"
							>
								<div id="search-field" style={{ width: '100%' }}>
									<Search id="search-icon" class="search-icon" />
									<input
										type="text"
										value={this.state.searchValue}
										onChange={(e) => this.handleSearch(e)}
										className="qrCode-search-bar"
										id="header-search"
										placeholder="Click here and scan OR type QR code / SR Number"
									/>
								</div>
								<div
									style={{
										width: '100%',
									}}
								>
									{this.state.searchValue.length >= 8 &&
									this.state.showError === true ? (
										<p
											style={{
												color: 'red',
												textAlign: 'left',
												marginTop: '20px',
												// marginRight: '68%',
											}}
										>
											Wrong Qr Code or SR Number Entered
										</p>
									) : (
										<></>
									)}
								</div>

								<table
									className="memoryCardSumaryTable"
									style={{
										marginTop: '40px',
										borderLeft: '0.5px solid  #383838',
										borderTop: '0.5px solid  #383838',
										color: 'white',
										width: '100%',
									}}
								>
									<tr style={{ color: '#B0B0B0' }}>
										<th style={{ textAlign: 'left' }}>QR CODE</th>
										<th style={{ textAlign: 'left' }}>PROJECTS</th>
										<th style={{ textAlign: 'left' }}>TYPE</th>
										<th style={{ textAlign: 'left' }}>SIZE</th>
										<th style={{ textAlign: 'left' }}>BRANCH</th>
										<th style={{ textAlign: 'left' }}></th>
									</tr>
									{this.state.hardDriveInfoList.length > 0 &&
										this.state.hardDriveInfoList.map((el) => {
											return (
												<>
													{el !== {} ? (
														<tr>
															<td
																style={{
																	display: 'flex',
																	flexDirection: 'column',
																	gap: '8px',
																}}
															>
																<p>{el.qrCode}</p>
																<p
																	style={{
																		color: '#707070',
																	}}
																>
																	{el.manufacturerId}
																</p>
															</td>
															<td>
																<span
																	style={{
																		display: 'flex',
																		flexDirection: 'column',
																		gap: '8px',
																	}}
																>
																	<p>{el.projectTitle}</p>
																	<p
																		style={{
																			color: '#707070',
																		}}
																	>
																		{this.getWorkspacekey(
																			el.tenantId,
																		) +
																			'-' +
																			el.projectSlNo}
																	</p>
																</span>
															</td>
															<td>
																<span
																	className={`completed-shoots `}
																	style={{
																		// marginTop: '-120px',

																		display: 'flex',
																		// justifyContent: 'flex-start',
																		alignItems: 'center',
																		textTransform: 'uppercase',
																		fontSize: '14px',
																	}}
																>
																	<b
																		style={{
																			width: '10px',
																			height: '10px',
																			minHeight: '10px',
																			minWidth: '10px',
																			borderRadius: '2px',
																			backgroundColor:
																				el.category ===
																				'working'
																					? '#03A0FF'
																					: el.category ===
																					  'backup'
																					? '#FE2C2B'
																					: '#7B7B7B',
																			marginRight: 5,
																			display: 'flex',
																		}}
																	></b>
																	{el.category === 'working'
																		? 'WORKING'
																		: el.category === 'backup'
																		? 'BACKUP'
																		: 'SECURE'}
																	{/* <p>{this.props.data.status}</p> */}
																</span>
															</td>
															<td
															// style={{
															//     display: 'flex',
															// }}
															>
																{el.size} TB
															</td>
															<td>{el.branch?.branchId}</td>
															<td>
																<Minus
																	onClick={() =>
																		this.minusClickHandler(
																			el.id,
																			el.qrCode,
																		)
																	}
																	style={{
																		height: '30px',
																		width: '30px',
																		cursor: 'pointer',
																	}}
																/>
															</td>
														</tr>
													) : (
														<></>
													)}
												</>
											);
										})}
								</table>
							</div>
							<div
								className="assignHardDriveRight"
								style={{
									width: '30%',
									height: '100vh',
									backgroundColor: '#242424',
									display: 'flex',
									flexDirection: 'column',
									// justifyContent: 'center',
									gap: '30px',
									padding: '30px',
								}}
							>
								<label
									style={{
										color: '#B0B0B0',
										marginTop: '24px',
										// fontSize: '14px',
										fontFamily: 'Inter',
										fontStyle: 'normal',
										fontWeight: 400,
										fotnSize: '13px',

										letterSpacing: '-0.3px',
									}}
								>
									Received at*
								</label>

								{/* <option value="apple">Apple</option>
                                <option value="banana">Banana</option>
                                <option value="orange">Orange</option> */}
								{/* </select> */}
								<Select
									required
									value={this.state.selectedValue}
									className="cost-select-container"
									classNamePrefix="cost-select"
									options={this.state.branchesListOption}
									onChange={(e) => {
										this.setState({
											selectedValue: e,
										});
									}}
									// defaultValue={
									//     _.filter(this.state.workspacesOptions, {
									//         value: this.state.createShootWorkspace,
									//     })[0]
									// }
									isSearchable={true}
									menuPortalTarget={document.body}
									menuPosition={'fixed'}
								/>
								<label
									style={{
										color: '#B0B0B0',
										marginTop: '24px',
										fontFamily: 'Inter',
										fontStyle: 'normal',
										fontWeight: 400,
										fotnSize: '13px',

										letterSpacing: '-0.3px',
									}}
								>
									Receive from
								</label>

								{/* <option value="apple">Apple</option>
                                <option value="banana">Banana</option>
                                <option value="orange">Orange</option> */}
								{/* </select> */}
								<Select
									required
									value={this.state.selectedValue2}
									className="cost-select-container"
									classNamePrefix="cost-select"
									options={this.state.namesList2}
									onChange={
										(e) => {
											this.setState({
												name: e.label,
												id: e.value,
												selectedValue2: e,
											});
										}
										// this.handleCreateShootSelect(e, 'Workspace')
									}
									// onChange={(e) =>
									//     this.handleCreateShootSelect(e, 'Workspace')
									// }
									// defaultValue={
									//     _.filter(this.state.workspacesOptions, {
									//         value: this.state.createShootWorkspace,
									//     })[0]
									// }
									isSearchable={true}
								/>

								<label style={{ color: '#B0B0B0', fontSize: '20px' }}>Notes</label>
								<textarea
									name=""
									id=""
									cols="30"
									rows="10"
									style={{
										background: 'transparent',
										padding: '10px',
										border: '1px dotted white',
										fontFamily: 'Inter',
										fontStyle: 'normal',
										fontWeight: 500,
										fontSize: '14px',
										lineHeight: '24px',
										color: this.state.note === '' ? '#B0B0B0' : '#f5f5f5',
										/* identical to box height, or 171% */

										letterSpacing: '-0.3px',
									}}
									value={this.state.note}
									placeholder="Type here..."
									onInput={(e) => this.setState({ note: e.target.value })}
								>
									{this.state.note}
								</textarea>
							</div>
						</div>
					</div>
				) : (
					<>
						<div className="layout-wrapper">
							<LoadingBar />
						</div>
					</>
				)}
			</>
		);
	}
}
export default withRouter(ReceiveHardDrives);
